

























import { Component, Vue, Prop } from 'vue-property-decorator';
import ArticleMeta from '@/components/article/ArticleMeta.vue';
import VTag from '@/components/VTag.vue';
import marked from 'marked';
import { articleService } from '../services';
import { Article } from '@/services/articles';

@Component({
  components: {
    ArticleMeta,
    VTag
  }
})
export default class ArticleView extends Vue {
  @Prop() slug!: string;

  created() {
    this.$store.dispatch('articles/fetchArticle', this.slug);
  }

  get article(): Article {
    return this.$store.getters['articles/article'];
  }

  beforeDestroy() {
    this.$store.dispatch('articles/resetState');
  }

  parseMarkdown(body: string) {
    return marked(body);
  }
}
